import { render, staticRenderFns } from "./CarouselFeatured.vue?vue&type=template&id=84f1a5fe&"
import script from "./CarouselFeatured.vue?vue&type=script&lang=js&"
export * from "./CarouselFeatured.vue?vue&type=script&lang=js&"
import style0 from "./CarouselFeatured.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports